// src/api/executive/sales.api.tsx
import BaseAPI from 'api/api'
import type {
  CategoryMixResponse,
  GetCategoryMixParams,
  GetPaymentMethodMixParams,
  GetSalesSummaryParams,
  GetTopDoctorsParams,
  GetTopProceduresParams,
  GetTopProductsParams,
  PaymentMethodMixResponse,
  SalesSummaryResponse,
  TopDoctorsResponse,
  TopProceduresResponse,
  TopProductsResponse,
} from './executive.types'

const path = 'executive/sales'

export default class SalesApi extends BaseAPI {
  static async getTopProcedures(
    params: GetTopProceduresParams
  ): Promise<TopProceduresResponse> {
    const res = await BaseAPI.api.get(`${path}/top-procedures`, { params })
    return res.data
  }

  static async getTopDoctors(
    params: GetTopDoctorsParams
  ): Promise<TopDoctorsResponse> {
    const res = await BaseAPI.api.get(`${path}/top-doctors`, { params })
    return res.data
  }

  static async getTopProducts(
    params: GetTopProductsParams
  ): Promise<TopProductsResponse> {
    const res = await BaseAPI.api.get(`${path}/top-products`, { params })
    return res.data
  }

  static async getCategoryMix(
    params: GetCategoryMixParams
  ): Promise<CategoryMixResponse> {
    const res = await BaseAPI.api.get(`${path}/category-mix`, { params })
    return res.data
  }

  static async getSalesSummary(
    params: GetSalesSummaryParams
  ): Promise<SalesSummaryResponse> {
    const res = await BaseAPI.api.get(`${path}/summary`, { params })
    return res.data
  }

  static async getPaymentMethodMix(
    params: GetPaymentMethodMixParams
  ): Promise<PaymentMethodMixResponse> {
    const res = await BaseAPI.api.get(`${path}/payment-method-mix`, { params })
    return res.data
  }
}
